const zurichParts = (value) => Object.fromEntries(
  new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Zurich",
    year: "numeric", month: "2-digit", day: "2-digit",
    weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(new Date(value)).filter((part) => part.type !== "literal").map((part) => [part.type, part.value]),
);

export const zurichDateKey = (value) => {
  const parts = zurichParts(value);
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export function calendarMonthDays(month) {
  if (!/^\d{4}-\d{2}$/.test(month || "")) return [];
  const [year, monthNumber] = month.split("-").map(Number);
  const firstWeekday = new Date(Date.UTC(year, monthNumber - 1, 1)).getUTCDay();
  const daysInMonth = new Date(Date.UTC(year, monthNumber, 0)).getUTCDate();
  return [
    ...Array((firstWeekday + 6) % 7).fill(null),
    ...Array.from({ length: daysInMonth }, (_, index) => `${month}-${String(index + 1).padStart(2, "0")}`),
  ];
}

export function publicAvailableSlots({ availabilityView = "", from, intervalMinutes = 15, durationMinutes = 45, bufferMinutes = 30, bookableFrom, bookableTo, minimumNoticeHours = 12, now = new Date() }) {
  const rangeStart = new Date(from);
  if (!Number.isFinite(rangeStart.getTime()) || !availabilityView) return [];
  const intervalsNeeded = Math.ceil(durationMinutes / intervalMinutes);
  const bufferIntervals = Math.ceil(bufferMinutes / intervalMinutes);
  const result = [];
  const earliestStart = new Date(now).getTime() + minimumNoticeHours * 60 * 60 * 1000;
  for (let index = 0; index + intervalsNeeded <= availabilityView.length; index += 1) {
    const before = Math.max(0, index - bufferIntervals);
    const after = Math.min(availabilityView.length, index + intervalsNeeded + bufferIntervals);
    if (![...availabilityView.slice(before, after)].every((value) => value === "0")) continue;
    const start = new Date(rangeStart.getTime() + index * intervalMinutes * 60000);
    const end = new Date(start.getTime() + durationMinutes * 60000);
    if (start.getTime() < earliestStart || (bookableFrom && start < new Date(bookableFrom)) || (bookableTo && end > new Date(bookableTo))) continue;
    const startParts = zurichParts(start);
    const endParts = zurichParts(end);
    if (`${startParts.year}-${startParts.month}-${startParts.day}` !== `${endParts.year}-${endParts.month}-${endParts.day}`) continue;
    const startMinutes = Number(startParts.hour) * 60 + Number(startParts.minute);
    const endMinutes = Number(endParts.hour) * 60 + Number(endParts.minute);
    if (["Sat", "Sun"].includes(startParts.weekday) || startMinutes < 9 * 60 || endMinutes > 18 * 60) continue;
    result.push({ starts_at: start.toISOString(), ends_at: end.toISOString() });
  }
  return result;
}

export function groupPublicSlots(slots, lang = "it") {
  const locale = lang === "en" ? "en-GB" : "it-CH";
  return slots.reduce((groups, slot) => {
    const key = new Intl.DateTimeFormat(locale, {
      timeZone: "Europe/Zurich", weekday: "long", day: "2-digit", month: "long",
    }).format(new Date(slot.starts_at));
    (groups[key] ||= []).push(slot);
    return groups;
  }, {});
}

export function appointmentTime(value, lang = "it") {
  return new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "it-CH", {
    timeZone: "Europe/Zurich", dateStyle: "full", timeStyle: "short",
  }).format(new Date(value));
}
